<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="评论内容" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.idValue" @input="onInput" class="input-with-select" size="small">
                        <el-select v-model="params.idType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="巡演ID" :value="2"></el-option>
                            <el-option label="众筹ID" :value="3"></el-option>
                            <el-option label="小站ID" :value="4"></el-option>
                            <el-option label="视频ID" :value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.display" placeholder="请选择"  size="small">
                        <el-option label="不限制状态" :value="-1"></el-option>
                        <el-option label="仅看开放的" :value="1"></el-option>
                        <el-option label="仅看屏蔽的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.mainType" placeholder="请选择"  size="small">
                        <el-option label="不限制状态" :value="-1"></el-option>
                        <el-option label="仅看演出的" :value="6"></el-option>
                        <el-option label="仅看众筹的" :value="8"></el-option>
                        <el-option label="仅看艺人的" :value="2"></el-option>
                        <el-option label="仅看场地的" :value="3"></el-option>
                        <el-option label="仅看厂牌的" :value="5"></el-option>
                        <el-option label="仅看视频的" :value="9"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <el-date-picker
                        v-model="params.datetimerange"
                        type="datetimerange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" 
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        unlink-panels
                        class="fl"
                        size="small">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-download"
                v-if="$utils.have('/letter/export')"
                :loading="exportLoading"
                @click="onExport"
                size="small"
                >导出评论</el-button
            >
            <el-button
                type="primary"
                v-if="$utils.have('/letter/forbidden/list')"
                icon="el-icon-document-delete"
                @click="$router.push({path: `/operation/comment/shield`})"
                size="small"
                >屏蔽词汇</el-button
            >
            <el-button
                type="primary"
                v-if="$utils.have('/letter/batchDisplay')"
                @click="onBatch"
                size="small"
                >批量操作</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column width="60" label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.display === 1">展示</p>
                        <p v-else-if="scope.row.display === 0">屏蔽</p>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" label="评论用户ID">
                    <template slot-scope="scope">
                        <router-link class="el-link el-link--primary" style="display: initial;" :to="`/user/fans/list?userId=${scope.row.fromUserId}`">{{ scope.row.fromUserId }}</router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="fromUserName" label="评论用户名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="评论内容" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <router-link class="el-link el-link--primary" style="display: initial;" :to="`/operation/comment/detail/${scope.row.id}`">{{ scope.row.content }}</router-link>
                    </template>
                </el-table-column>
                <el-table-column width="130" label="评论图片">
                    <template slot-scope="scope">
                        <!-- <el-image style="width: 40px; height: 40px;margin: 0 5px;" v-for="(image, index) in scope.row.photoList" fit="cover" :src="image" :preview-src-list="[image]" :key="index">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image> -->
                        <el-image v-if="scope.row.photoList && scope.row.photoList.length == 1" :src="scope.row.photoList[0] | coverImage(120,120)" fit="cover" :preview-src-list="[scope.row.photoList[0]]"></el-image>
                        <el-button v-else-if="scope.row.photoList && scope.row.photoList.length > 1" type="text" size="mini" @click="preiewImg(scope.row.photoList)">多图</el-button>
                    </template>
                </el-table-column>
                <el-table-column width="150" prop="createTime" label="评论时间"></el-table-column>
                <el-table-column min-width="100" label="评论对象类型">
                    <template slot-scope="scope">
                        <p v-if="scope.row.mainType === 6 || scope.row.mainType === 0">演出</p>
                        <p v-else-if="scope.row.mainType === 8">众筹</p>
                        <p v-else-if="scope.row.mainType === 2">艺人</p>
                        <p v-else-if="scope.row.mainType === 3">场地</p>
                        <p v-else-if="scope.row.mainType === 5">厂牌</p>
                        <p v-else-if="scope.row.mainType === 9">视频</p>
                    </template>
                </el-table-column>
                <el-table-column prop="mainId" width="100" label="评论对象ID"></el-table-column>
                <el-table-column prop="mainName" label="评论对象名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="appVersion" label="APP版本"></el-table-column>
                <el-table-column label="手机系统">
                    <template slot-scope="scope">
                        <p>{{ scope.row.terminal || '' }}{{ scope.row.sysVersion || '' }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="modifyUserName" label="最后操作人" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" min-width="180" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-s-comment"
                            @click="$router.push({path: `/operation/comment/detail/${scope.row.id}`})"
                            >回复</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="onDisplay(scope.row)"
                            >{{ scope.row.display === 0 ? '展示' : '屏蔽' }}</el-button
                        >
                        <el-button
                            v-if="scope.row.mainType === 9"
                            type="text"
                            size="small"
                            @click="onHot(scope.row.id, scope.row.isHot ? 0 : 1)"
                            >{{ scope.row.isHot ? '取消热评' : '设为热评' }}</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            v-if="scope.row.mainType === 6"
                            @click="topId=scope.row.id;mainId=scope.row.mainId;topVisible = true;"
                            >设置置顶</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
        <comment-top :visible.sync="topVisible" :id="topId" :mainId="mainId" @onRefresh="fetch"></comment-top>
        <el-dialog :visible.sync="photoListView" title="评论图片" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList" fit="cover" :src="image | coverImage(200,200)" :preview-src-list="photoList.slice(index).concat(photoList.slice(0,index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
import dayjs from 'dayjs'; // 导入日期js
import CommentTop from './top';
const defaultQuery = {
    pageNo: 1,
    rangeEnd: '',
    rangeStart: '',
    idType: 1,
    idValue: '',
    display: -1,
    mainType: 6,
    type: 1,
    value: '',
    datetimerange: [dayjs().subtract(1, 'months').startOf('months').add(dayjs().date(), 'day').startOf('hour').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
};
export default {
    components: {
        CommentTop
    },
    data() {
        return {
            topVisible: false,
            params: {
                ...defaultQuery,
                mainType: parseInt(this.$route.query.mainType || 6),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                datetimerange: this.$route.query.rangeStart ? [this.$route.query.rangeStart || '', this.$route.query.rangeEnd || ''] : defaultQuery.datetimerange,
            },
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
            exportLoading: false,
            topId: '',
            mainId: '',
            batchs: [],
            photoList: [],
            photoListView: false
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        onBatch () {
            if(this.batchs.length <= 0) return this.$message.error('请至少勾选一个评论数据');
            this.$confirm(`请选择批量操作类型`, '批量操作', {
                type: 'warning',
                center: true,
                closeOnClickModal: false,
                confirmButtonText: '批量展示',
                cancelButtonText: '批量屏蔽',
                callback: async (action) => {
                    if(action === 'cancel' || action === 'confirm') {
                        const response = await this.$request({
                            url: "/letter/batchDisplay",
                            method: "POST",
                            data: {
                                display: action === 'cancel' ? 0 : 1,
                                ids: this.batchs
                            },
                        })
                        const {state, msg} = response.data;
                        if (state != 1) return this.$message.error(msg);
                        this.$message.success('操作成功');
                        this.fetch();
                    }
                }
            })
        },
        handleSelectionChange (rows) {
            this.batchs = rows.map(item => item.id);
        },
        onInput (value) {
            if (!/^[0-9]+$/.test(value)) this.params.idValue = '';
        },
        async fetch() {
            if(dayjs(this.params.datetimerange[0]).add(50, 'day').isBefore(dayjs(this.params.datetimerange[1]))) return this.$message.error('目前仅支持查询最多50天内的数据');
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/letter/list",
                method: "POST",
                data: {
                    ...this.params,
                    rangeEnd: this.params.datetimerange && this.params.datetimerange[1] || null,
                    rangeStart: this.params.datetimerange && this.params.datetimerange[0] || null
                },
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        onDisplay(reply) {
            this.$confirm(`确认要${reply.display === 0 ? '展示' : '屏蔽'}该条回复`, '屏蔽/展示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/letter/display",
                    method: "POST",
                    data: {id: reply.id, type: reply.display === 0 ? 1 : 2},
                });
                const {msg, state} = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('操作成功');
                this.fetch();
            })
        },
        // 导出评论
        async onExport () {
            if(dayjs(this.params.datetimerange[0]).add(50, 'day').isBefore(dayjs(this.params.datetimerange[1]))) return this.$message.error('目前仅支持查询最多50天内的数据');
            this.exportLoading = true;
            const response = await this.$request({
                url: "/letter/export",
                method: "POST",
                data: {
                    ...this.params,
                    rangeEnd: this.params.datetimerange && this.params.datetimerange[1] || null,
                    rangeStart: this.params.datetimerange && this.params.datetimerange[0] || null
                },
            })
            const {state, msg, result} = response.data;
            this.exportLoading = false;
            if (state != 1) return this.$message.error(msg);
            if(result.url) downloadFileTmp(result.url, '评论.xlsx');
        },
        async onHot (id, isHot) {
            const response = await this.$request({
                url: "/letter/editIsHot",
                method: "POST",
                data: {id, isHot},
            });
            const {msg, state} = response.data;
            if (state != 1) return this.$message.error(msg);
            this.$message.success('热评操作成功');
            this.fetch();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultQuery,
                pageSize: this.params.pageSize,
            };
            this.search();
        },

        preiewImg(list){
            this.photoList = list;
            this.photoListView = true;
        }
    },
};
</script>
